/*
 *   Copyright 2020 Jonathan RodrÃ­guez Vaca
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *   http://www.apache.org/licenses/LICENSE-2.0
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { Data, DataSet, Edge, Locales, Node, Options } from 'vis-network/standalone';
import { NgxVisNetworkEtsisiDirective } from './ngx-vis-network-etsisi.directive';
import { NgxVisNetworkEtsisiService } from './ngx-vis-network-etsisi.service';

export { Data, DataSet, Edge, Locales, NgxVisNetworkEtsisiDirective, NgxVisNetworkEtsisiService, Node, Options };

@NgModule({
  declarations: [NgxVisNetworkEtsisiDirective],
  imports: [CommonModule],
  exports: [NgxVisNetworkEtsisiDirective],
  providers: [NgxVisNetworkEtsisiService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class NgxVisNetworkEtsisiModule {}
